import React from "react";
import "./styles.scss";
import UserTag from "../../UserTag";
import { logout } from "../../../../../api/authentication";
import { Link, useHistory } from "react-router-dom";
import { ReactComponent as DropdownArrow } from "../../../../../public/shared/dropdown-arrow.svg";
import { Dropdown } from "react-bootstrap";

export default ({ user }) => {
  const history = useHistory();

  const handleLogoutClick = () => {
    history.push("/logout");
  };

  const CustomUserTag = React.forwardRef(({ onClick }, ref) => (
    <div id="customUserTag" className="d-flex align-items-center" ref={ref} onClick={onClick}>
      <UserTag className="text-primary" user={user} disabled />
      <DropdownArrow className="ml-2" />
    </div>
  ));
  return (
    <Dropdown>
      <Dropdown.Toggle as={CustomUserTag} id="custom_toggler" />
      <Dropdown.Menu>
        <Dropdown.Item
          as={React.forwardRef((props, ref) => (
            <a className="dropdown-item" href={`/${user.slug}`}>
              My Profile
            </a>
          ))}
        />
        <Dropdown.Item onClick={handleLogoutClick}>Logout</Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};
